import React, { useState } from 'react';
import WeatherData from '../../core/WeatherData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudRain, faTemperatureQuarter, faWater, faStar, faChartArea, faTableColumns } from '@fortawesome/free-solid-svg-icons';
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons';
import RainStats from './stats/RainStats';
import HumidityStats from './stats/HumidityStats';
import TemperatureStats from './stats/TemperatureStats';
import RiverLevelStats from './stats/RiverLevelStats';
import WindStats from './stats/WindStats';
import AirPressureStats from './stats/AirPressureStats';
import RainChartComponent from './charts/RainChart';
import RiverChartComponent from './charts/RiverChart';
import TemperatureChartComponent from './charts/TemperatureChart';
import './CityCard.css';

interface CityCardProps {
    weatherData: WeatherData;
    isFavorite: boolean;
    favoriteCallback: (cityName: string, isFavorite: boolean) => void;
}

const CityCardComponent: React.FC<CityCardProps> = ({ weatherData, isFavorite, favoriteCallback }) => {
    const [showCurrent, setShowCurrent] = useState(true);
    const [riverChart, setRiverChart] = useState(true);
    const [rainChart, setRainChart] = useState(false);
    const [temperatureChart, setTemperatureChart] = useState(false);

    const toggleFavorite = () => {
        favoriteCallback(weatherData.getName(), !isFavorite);
    };

    const toggleCurrentView = () => {
        setShowCurrent(!showCurrent);
    };

    const showRiverChart = () => {
        setRiverChart(true);
        setRainChart(false);
        setTemperatureChart(false);
    };

    const showRainChart = () => {
        setRiverChart(false);
        setRainChart(true);
        setTemperatureChart(false);
    };

    const showTemperatureChart = () => {
        setTemperatureChart(true);
        setRiverChart(false);
        setRainChart(false);
    };

    const displayIcon = showCurrent ? faChartArea : faTableColumns;
    const icon = isFavorite ? faStar : farStar;

    let data;
    if (showCurrent) {
        data = <div><div className="metrics columns is-mobile">            
            <RainStats isLoaded={weatherData.isLoaded()} rain={weatherData.getCurrentRain()}></RainStats>
            <HumidityStats isLoaded={weatherData.isLoaded()} humidity={weatherData.getHumidity()}></HumidityStats>
            <WindStats isLoaded={weatherData.isLoaded()} windSpeed={weatherData.getWindSpeed()} windDirection={weatherData.getWindDirection()}></WindStats>
        </div>
            <div className="metrics columns is-mobile">
                <TemperatureStats isLoaded={weatherData.isLoaded()} temperature={weatherData.getTemperature()} temperatureFeel={weatherData.getTemperatureFeel()}></TemperatureStats>
                <RiverLevelStats isLoaded={weatherData.isLoaded()} level={weatherData.getRiverLevel()} levelChange={weatherData.getLevelDifference()}></RiverLevelStats>
                <AirPressureStats isLoaded={weatherData.isLoaded()} airPressure={weatherData.getAirPressure()}></AirPressureStats>
            </div>
        </div>
    } else {
        const riverClass = riverChart ? 'is-link is-light is-active' : '';
        const rainClass = rainChart ? 'is-link is-light is-active' : '';
        const temperatureClass = temperatureChart ? 'is-link is-light is-active' : '';
        const chartTypeToggle =
            (<div className="chart-type">
                <button className={`button is-small ${riverClass}`} onClick={showRiverChart}><FontAwesomeIcon color='blue' icon={faWater} /></button>
                <button className={`button is-small ${rainClass}`} onClick={showRainChart}><FontAwesomeIcon color='gray' icon={faCloudRain} /></button>
                <button className={`button is-small ${temperatureClass}`} onClick={showTemperatureChart}><FontAwesomeIcon color='orange' icon={faTemperatureQuarter} /></button>
            </div>)
        if (riverChart) {
            const levels = weatherData.getRiverLevels();     
            data = <div>
                <div className='chart-title'><FontAwesomeIcon color='lightblue' icon={faWater} /><span>Nível do Rio</span></div>
                <RiverChartComponent weatherData={weatherData} />
                {chartTypeToggle}
            </div>                
        } else if (rainChart) {
            data = <div>
                <div className='chart-title'><FontAwesomeIcon color='gray' icon={faCloudRain} /><span>Chuva (mm)</span></div>
                <RainChartComponent weatherData={weatherData} />
                {chartTypeToggle}
            </div>
        } else if (temperatureChart) {                
            data = (<div>
                <div className='chart-title'><FontAwesomeIcon color='orange' icon={faTemperatureQuarter} /><span>Temperatura (ºC)</span></div>
                <TemperatureChartComponent weatherData={weatherData} />
                {chartTypeToggle}
            </div>)
        }
    }

    return (
        <div className="column is-one-third">
            <div className="box">
                <div className="city-header">
                    <FontAwesomeIcon color='darkSlateBlue' className="toggle-current" icon={displayIcon} onClick={toggleCurrentView}></FontAwesomeIcon>
                    <div className="city-name is-size-4">{weatherData.getName()}</div>
                    <FontAwesomeIcon color='gold' className="toggle-favorite" icon={icon} onClick={toggleFavorite}></FontAwesomeIcon>
                </div>
                {data}
            </div>
        </div>
    )
};

export default CityCardComponent;
